<template>
  <div class="event-items">
    <div class="feed feed--events container--1240">
      <h2 class="feed__title" v-if="events.length > 0 && !loading">
        {{ title }}
      </h2>
      <h2 class="feed__title" v-else-if="!events.length && !loading">
        There are currently no events found with these filters, please update the filters to find more events
      </h2>

      <div class="feed__items feed__items--events" ref="infinite">
        <Event
          v-for="event in events"
          :key="event.id"
          :title="event.title"
          :image="event.image"
          :link="event.link"
          :primary-format="event.primary_format"
          :time="event.time"
          :day="event.day"
          :month="event.month"
          :location="event.location"
        />
      </div>
      <Loading v-if="loading" :color="loadingColor" />
    </div>
  </div>
</template>

<script>
import store from '../store/store';
import Event from './Event';
import Loading from './Loading';

import { mapGetters } from 'vuex';
export default {
  name: 'Feed',
  store: store,
  mounted () {
    store.dispatch('rf/returnEvents');
    window.addEventListener('scroll', this.infiniteLoadScrollEvent);
  },
  data: () => ({
    loadingColor: '#ffffff'
  }),
  methods: {
    infiniteLoadScrollEvent () {
      const dimensions = this.$refs.infinite.getBoundingClientRect();
      if (dimensions.top + dimensions.height - window.innerHeight < 0) {
        store.dispatch('rf/returnEvents');
      }
    }
  },
  computed: {
    ...mapGetters({
      events: 'rf/getEvents',
      title: 'rf/getTitle',
      searchTerm: 'rf/getSearchTerm',
      loading: 'rf/getLoading'
    })
  },
  components: {
    Event,
    Loading
  }
};
</script>

<style></style>
